<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>

    <div v-else>
      <v-card flat>
        <PrintViewBar
          v-if="Order"
          :showEmailBtn="showEmailBtn"
          :id="Order.id"
          type="order"
          @generatePDF="generatePDF"
          :title="`Order # ${Order.localId}`"
          :postfix="`view?key=${currentBusiness.code}`"
          :name="currentBusiness.name"
          :email="`${Order.Customer && Order.Customer.email ? Order.Customer.email : ''}`"
          :obj="Order.Customer"
          :text="`Invoice from ${currentBusiness.name} click the link to view`"
        />

        <v-container fluid grid-list-lg ref="testElement">
          <v-card-text class="pb-0">
            <v-layout row wrap>
              <v-flex class="text-left text-capitalize">
                <div class="headline font-weight-bold">
                  {{ currentBusiness.name }}
                </div>
                <div class="font-weight-medium" v-if="currentBusiness.address">
                  {{ currentBusiness.address }} {{ currentBusiness.city }},
                  <span class="text-uppercase">{{ currentBusiness.state }}</span>
                  {{ currentBusiness.zip }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.phoneNumber }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.email }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.website }}
                </div>

                <div class="mt-2 display-3 font-weight-black blue--text">
                  SALE ORDER
                </div>

                <div class="font-weight-regular" v-if="Order.Customer && Order.Customer.name">
                  <div class="font-weight-medium">BILL TO</div>
                  <div>{{ Order.Customer.name }}</div>
                  <div>{{ Order.Customer.address }}</div>
                  <div v-if="Order.Customer.city">
                    {{ Order.Customer.city }},<span class="text-uppercase">{{ Order.Customer.state }}</span>
                    {{ Order.Customer.zip }}
                  </div>
                </div>
                <div class="font-weight-regular" v-else>
                  <div class="font-weight-medium">BILL TO</div>
                  <div>{{ Order.metadata.name }}</div>
                  <div>{{ Order.metadata.phoneNumber }}</div>
                </div>
              </v-flex>

              <v-spacer></v-spacer>

              <v-flex shrink class="text-right">
                <div v-if="!$vuetify.breakpoint.xsOnly">
                  <img width="130" class="logo" :src="currentBusiness.imageUrl" alt="" />
                </div>

                <div class="font-weight-regular mt-2">
                  <v-layout row>
                    <v-flex>
                      <div class="text-right">ORDER #</div>
                      <div class="text-right">DATE:</div>
                      <div class="text-right" v-if="Order.SalesRep">SALES REP:</div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                      <div class="text-left">{{ Order.localId }}</div>
                      <div class="text-left">{{ Order.date | moment("MM/DD/YYYY") }}</div>
                      <div class="text-left" v-if="Order.SalesRep">{{ Order.SalesRep.name }}</div>
                      <div class="text-left" v-if="Order.User">{{ Order.User.name }}</div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>

          <table class="center">
            <tbody class="report-container">
              <v-card-text>
                <v-data-table
                  dense
                  :headers="headers"
                  hide-default-footer
                  :items-per-page="Order.OrderDetails.length"
                  :items="Order.OrderDetails"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-center" v-if="!hideImageOnOrder">
                        <v-avatar tile v-if="item.Product && item.Product.imageUrl" size="50">
                        
                          <v-img
                            class="no-print"
                            contain
                            :src="item.Product.imageUrl"
                            alt="Product image"
                          ></v-img>
                          <img
                            class="print-only"
                            :src="item.Product.imageUrl"
                            alt="Product image"
                            style="width:50px;height:50px;object-fit:contain;"
                          />
                        </v-avatar>
                      </td>

                      <td class="text-center">{{ item.qty }}</td>

                      <td class="text-left">
                        <div>{{ item.name }}</div>
                      </td>

                      <td class="text-right">
                        {{ item.price | currency }}
                      </td>

                      <td class="text-right">
                        {{ (item.price * item.qty) | currency }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>

          <v-card-text class="pr-4">
            <v-divider></v-divider>

            <v-row>
              <v-col cols="3">
                <div class="font-weight-medium" v-if="Order.OrderDetails">
                  {{ totalQty }} ITEMS
                </div>

                <div class="signature">
                  <v-divider></v-divider>
                  <div>Signature</div>
                </div>
              </v-col>

              <v-spacer></v-spacer>

              <v-col cols="7">
                <v-row>
                  <v-col>
                    <div class="font-weight-medium text-right">SUBTOTAL:</div>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col>
                    <div class="font-weight-medium text-right">
                      {{ Order.total | currency }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <div v-if="currentBusiness.policy">
              <div class="font-weight-medium">POLICY</div>
              <v-divider></v-divider>
              <div style="line-height: 12px">
                <small>{{ currentBusiness.policy }}</small>
              </div>
            </div>

            <v-col align="right">
              <img width="100" src="@/assets/images/poweredbylogo.png" alt="powered by" />
            </v-col>
          </v-card-text>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import orderService from "../service";
import PrintViewBar from "@/components/PrintViewBar";
import html2pdf from "html2pdf.js";
import Hashids from "hashids";
const hashids = new Hashids();
import { mapGetters, mapActions } from "vuex";

export default {
  name: "InvoiceView",
  data() {
    return {
      isLoading: true,
      showEmailBtn: false,
      Order: {
        OrderDetails: [],
      },
      headers: [],
      totalQty: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    hideImageOnOrder() {
      const b = this.currentBusiness;
      return !!(b && b.metadata && b.metadata.hideImageOnOrder);
    },
  },
  components: { PrintViewBar },
  created() {
    if (this.$route.meta.public) {
      this.loadPublicData();
    } else {
      this.loadData();
      if (!this.currentBusiness) this.initUser();
    }
  },
  watch: {
    currentBusiness() {
      this.loadHeaders();
    },
  },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    generatePDF() {
      const element = this.$refs.testElement;

      html2pdf()
        .from(element)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const blob = pdf.output("blob");
          const file = new File([blob], `Order-${this.Order.localId}.pdf`, {
            type: "application/pdf",
          });

          if (
            navigator.share &&
            navigator.canShare &&
            navigator.canShare({ files: [file] })
          ) {
            navigator
              .share({
                title: `Order # ${this.Order.localId}`,
                text: `here is your order from ${this.currentBusiness.name}`,
                files: [file],
              })
              .catch((err) => console.error("Share failed:", err));
          } else {
            html2pdf()
              .from(element)
              .set({
                margin: [0.5, 0.5, 2.0, 0.5],
                filename: `Invoice-${this.Order.localId}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                pagebreak: { mode: "avoid-all" },
                html2canvas: { scale: 1.5, logging: true, useCORS: true, backgroundColor: "#ffffff" },
                jsPDF: {
                  unit: "in",
                  format: [8.5, 30],
                  orientation: "portrait",
                },
              })
              .save();
          }
        });
    },
    loadHeaders() {
      this.headers = [];
      if (!this.currentBusiness?.metadata?.hideImageOnOrder) {
        this.headers.push({
          text: "Image",
          align: "center",
          value: "image",
          width: 50,
          sortable: false,
        });
      }
      this.headers.push(
        {
          text: `${this.currentBusiness?.metadata?.boxCountOnInventory ? "BOXES" : "QTY"}`,
          align: "center",
          value: "qty",
          width: 50,
          sortable: false,
        },
        {
          text: "ITEM NAME",
          align: "left",
          value: "productDetail",
          sortable: false,
        },
        {
          text: "PRICE",
          align: "right",
          value: "rate",
          width: 100,
          sortable: false,
        },
        {
          text: "TOTAL",
          align: "right",
          value: "total",
          width: 100,
          sortable: false,
        }
      );
    },
    loadPublicData() {
      const id = hashids.decode(this.$route.params.id);
      const key = this.$route.query.key;

      return orderService.publicGetById(id, { key }).then((response) => {
        this.Order = response.data;
        this.initBusiness(response.business);
        if (this.Order.OrderDetails) {
          this.totalQty = this.Order.OrderDetails.reduce((sum, r) => sum + parseInt(r.qty || 0, 10), 0);
        }
        this.isLoading = false;
      });
    },
    loadData() {
      const id = hashids.decode(this.$route.params.id);
      return orderService
        .getById(id)
        .then((response) => {
          this.Order = response.data;

          if (this.Order.Customer && this.Order.Customer.email) {
            this.showEmailBtn = true;
          }

          if (this.Order.OrderDetails) {
            this.totalQty = this.Order.OrderDetails.reduce((sum, r) => sum + parseInt(r.qty || 0, 10), 0);
          }

          this.isLoading = false;
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style scoped>
/* Helpers for print-only vs screen-only content */
.no-print { display: inline-block; }
.print-only { display: none; }

@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none !important;
  }
  .print-only {
    display: inline-block !important;
  }

  .no-print-important {
    display: none !important;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important; /* safe: our printable <img> doesn't rely on backgrounds */
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
</style>